<!--
**选择用户组件**
* userInfo: 指定当前选择的用户ID组
* CheckUserInfo: 返回选中的值给父组件
* isRadio: 为false时多选，true时多选
-->

<template>
  <div class="authUserCopm">
    <div class="authUserList flex">
      <div class="userTree">
        <el-tree
        ref="tree2"
        class="defineTree"
        :data="departList"
        highlight-current
        default-expand-all
        node-key="id"
        :expand-on-click-node="false"
        :props="adminTreeProp"
        @node-click="getUserList">
          <span class="custom-tree-node" slot-scope="{ node,data }">
            <i
              class="defineIcon"
              :class="{ 'el-icon-plus': !node.expanded, 'el-icon-minus':node.expanded, opacity: node.childNodes.length === 0}">
            </i>
            <span class="label" :class="data.id === treeCurrent ? 'selectedTree' : ''">{{ node.label }}</span>
          </span>
        </el-tree>
      </div>
      <div class="checkList">
        <div class="search">
          <el-input size="small" placeholder="请输入搜索内容" prefix-icon="el-icon-search" v-model="authUserform.search" @input="searchUser"></el-input>
        </div>
        <template v-if="!isRadio">
        <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
        <el-checkbox-group v-model="authUserform.userInfo" @change="handleCheckedCitiesChange">
          <el-checkbox v-for="(item,index) in transList" :label="item.user_id" :key="index">{{item.user_name}}</el-checkbox>
        </el-checkbox-group>
        </template>
        <template v-if="isRadio == true">
        <el-radio-group class="groupH mt10" v-model="authUserform.userInfo">
          <el-radio class="dblock" v-for="(item,index) in transList" :label="item.user_id" :key="index">{{item.user_name}}</el-radio>
        </el-radio-group>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import { showToast } from "../../static/js/utility/utility.js"
import { userApi,authApi,bussinessApi } from '../../static/js/api'
var vm
export default {
  name:'authUser',
  props:['userInfo','isRadio'],
  data(){
    return {
      authUserform:{
        userType:'0',//授权用户
        department:[],
        userInfo:[],//勾选中列表
        search:'',//搜索字段
        authUserType:'0',
      },
      departList:[],//部门级联列表
      adminTreeProp:{
        id:'id',
        label:'name',
        children:'children',
      },
      allAuthUser:[],
      checkAll: false,
      isIndeterminate: false,
      treeCurrent:'',
      //穿梭框渲染函数
      transList:[],
    }
  },
  async created(){
    vm = this
    vm.getDepartmentList()
  },
  mounted(){
    console.log('isRadio',vm.isRadio)
    //判断是否指定默认选中的用于ID组
    if(vm.userInfo){
      vm.authUserform.userInfo = vm.userInfo
    }
  },
  methods:{
    // 获取用户列表
    async getUserList(node){
      this.treeCurrent = node.id
      let data = {}
      
      if(vm.authUserform.authUserType != node.userType){
        vm.authUserform.userInfo = []
        vm.isIndeterminate = false
      }
      vm.authUserform.authUserType = node.userType
      data.user_type = node.userType
      data.is_bath = false;
      if(node.userType=='0'){
        if(node.id == '-1'){
          data.department_id = '0'
        }else{
          data.department_id = node.id
        }
      }
      
      let res = await authApi.getUserList(data)
      if (res.meta.code === 200) {
        vm.allAuthUser = res.data.list
        vm.searchUser()
      } else {
        showToast(res.meta.message)
      }
    },
    //筛选用户
    searchUser(){
      var allAuthUser = this.allAuthUser
      var searchList = []
      for(var i in allAuthUser){
        if(vm.authUserform.search!=''){
          if(allAuthUser[i].user_name.indexOf(vm.authUserform.search) != -1){
            searchList.push(allAuthUser[i])
          }
        }else{
          searchList = allAuthUser
        }
      }
      this.transList = searchList
    },
    //递归遍历树形数组
    forTree(data){
      var vm = this
      for(var i in data){
        data[i].userType = '0'
        if(data[i].children){
          vm.forTree(data[i].children)
        }
      }
    },
    //获取部门列表
    async getDepartmentList() {
      let res = await userApi.getDepartmentList()
      if (res.meta.code === 200) {
        vm.departList = []
        var arr = []
        vm.forTree(res.data)
        const obj = {
          id:'-1',
          name:'内部员工',
          children: res.data,
          userType:'0',
        }
        arr.push(obj)
        const obj2 = {
          id:'-2',
          name:'临时员工',
          userType:'2'
        }
        arr.push(obj2)
        vm.departList = arr
        
        vm.getUserList(obj)
        
      } else {
        showToast(res.meta.message)
      }
    },
    //全选
    handleCheckAllChange(val) {
      var arr = []
      for(var i in this.transList){
        arr.push(this.transList[i].user_id)
      }
      arr = Array.from(new Set(arr));//去重
      this.authUserform.userInfo = val ? arr : []
      this.isIndeterminate = false
    },
    //选择多个
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.transList.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.transList.length;
    },
  },
  watch:{
    'authUserform.userInfo'(newVal){
      console.log(newVal)
      //改变即返回选中数组给父组件
      vm.$emit('CheckUserInfo',newVal)
    },
  }
}
</script>
<style lang="scss">
.authUserCopm{
  .selectedTree{
    font-weight: bold;
  }
  .authUserList{
    border: 1px solid #eee;
    align-items: flex-start !important;
    .userTree{
      width: 44%;
      height: 300px;
      overflow-y: auto;
      border-right: 1px solid #eee;
      flex-shrink: 0;
    }
    .checkList{
      flex-grow: 1;
      .search{
        text-align: center;
        padding: 6px 0 0;
        .el-input{
          width: 70%;
          .el-input__inner{
            border-radius: 16px;
          }
        }
      }
      .el-checkbox,.el-radio{
        display: flex;
        justify-content: space-between;
        margin: 8px 0;
        flex-direction: row-reverse;
        padding-right: 16px;
        .el-checkbox__label,.el-radio__label{
          padding-left:16px;
        }
      }
      .el-checkbox-group,.el-radio-group{
        width: 100%;
        height: 227px;
        overflow-y: auto;
        border-top: 1px solid #eee;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/assets/authUser.vue